
import Vue, { PropType } from 'vue';
import { checkIfImageLoads } from '../assets';
import { get, isFunction } from 'lodash';

interface OverlayConfig {
    imageUrl: string,
    color: string
}

export default Vue.extend({
    name: 'Overlay',

    props: {
        config: {
            type: Object as PropType<OverlayConfig>,
            default: () => ({} as OverlayConfig)
        }
    },

    data(): Record<string, unknown> {
        return {
            imgUrl: null
        };
    },

    computed: {
        style(): Record<string, unknown> {
            return {
                backgroundColor: get(this, 'config.color', 'black')
            };
        }
    },

    watch: {
        config(): void {
            this.setImageUrl();
        }
    },

    mounted(): void {
        this.setImageUrl();
    },

    methods: {
        async setImageUrl(): Promise<void> {
            let imgUrl = get(this, 'config.imageUrl') as string | null;
            const getImageUrl = get(this, 'config.getImageUrl') as () => Promise<string>;
            imgUrl = imgUrl || (isFunction(getImageUrl) ? await getImageUrl() : null);
            this.imgUrl = (imgUrl && await checkIfImageLoads(imgUrl)) ? imgUrl : null;
        }
    }
});
